import React, { useState } from 'react';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import './NameEntry.css';

const NameEntry = ({ user, onComplete }) => {
    const [fullName, setFullName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!fullName.trim()) {
            setError('Please enter your name');
            return;
        }

        if (fullName.trim().length < 2) {
            setError('Name must be at least 2 characters long');
            return;
        }

        if (fullName.trim().length > 50) {
            setError('Name must be less than 50 characters');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            // Check if user document already exists
            const userRef = doc(db, 'users', user.uid);
            const userSnap = await getDoc(userRef);
            
            const nameValue = fullName.trim();
            const userData = {
                fullName: nameValue,
                name: nameValue,
                nameLower: nameValue.toLowerCase(),
                email: user.email,
                phoneNumber: user.phoneNumber || null,
                displayName: nameValue,
                profileComplete: true
            };

            // Only set createdAt if document doesn't exist
            if (!userSnap.exists()) {
                userData.createdAt = serverTimestamp();
            }

            // Create or update user document in Firestore
            await setDoc(userRef, userData, { merge: true });

            onComplete();
        } catch (error) {
            console.error('Error saving user data:', error);
            if (error.code === 'permission-denied') {
                setError('Permission denied. Please try logging out and back in.');
            } else if (error.code === 'network-request-failed') {
                setError('Network error. Please check your connection and try again.');
            } else {
                setError('Failed to save your information. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="name-entry-container">
            <div className="logo-section">
                <div className="logo-container">
                    <span className="music-icon">🎵</span>
                    <h1 className="logo-text">HubTune</h1>
                </div>
                <p className="tagline">Your Music Hub</p>
            </div>

            <div className="name-entry-box">
                <h1 className="name-entry-title">Complete Your Profile</h1>
                <p className="name-entry-subtitle">Tell us your name to get started</p>

                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                <form className="name-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="fullName" className="form-label">Enter Your Name *</label>
                        <input
                            type="text"
                            id="fullName"
                            placeholder="Enter your name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="submit-btn"
                        disabled={loading}
                    >
                        {loading ? 'Saving...' : 'Complete Profile'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default NameEntry;
